import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	notAcknowledged: {
		id: 'eoc.escalation-policies.common.ui.rule-input.not-acknowledged.no-translate',
		defaultMessage: 'Not acknowledged',
		description: 'Label of notify condition not acknowledged option',
	},
	notClosed: {
		id: 'eoc.escalation-policies.common.ui.rule-input.not-closed.no-translate',
		defaultMessage: 'Not closed',
		description: 'Label of notify condition not closed option',
	},
	ifTheAlertIs: {
		id: 'eoc.escalation-policies.common.ui.rule-input.if-the-alert-is.no-translate',
		defaultMessage: 'If the alert is',
		description: 'The prefix of notify condition input',
	},
	minutesAfterCreation: {
		id: 'eoc.escalation-policies.common.ui.rule-input.minutes-after-creation.no-translate',
		defaultMessage: 'minutes after creation,',
		description: 'The suffix of number input',
	},
	then: {
		id: 'eoc.escalation-policies.common.ui.rule-input.then.no-translate',
		defaultMessage: 'then',
		description: 'The prefix of notify type input',
	},
	notifyUser: {
		id: 'eoc.escalation-policies.common.ui.notify-user.no-translate',
		defaultMessage: 'Notify user',
		description: 'The label of notify type "notify user" option',
	},
	notifyUsersInSchedule: {
		id: 'eoc.escalation-policies.common.ui.notify-users-in-schedule.no-translate',
		defaultMessage: 'Notify on-call user(s) in schedule',
		description: 'The label of notify type "Notify on-call user(s) in schedule" option',
	},
	routeToTeam: {
		id: 'eoc.escalation-policies.common.ui.route-to-team.no-translate',
		defaultMessage: 'Route to team',
		description: 'The label of notify type "Route to team" option',
	},
	notifyNextUserInRotationForSchedule: {
		id: 'eoc.escalation-policies.common.ui.notify-next-user-in-rotation-for-schedule.no-translate',
		defaultMessage: 'Notify next user (in rotation) for schedule',
		description: 'The label of notify type "Notify next user (in rotation) for schedule" option',
	},
	notifyPreviousUserInRotationForSchedule: {
		id: 'eoc.escalation-policies.common.ui.notify-previous-user-in-rotation-for-schedule.no-translate',
		defaultMessage: 'Notify previous user (in rotation) for schedule',
		description:
			'The label of notify type "Notify previous user (in rotation) for schedule" option',
	},
	notifyAllMembersOfTeam: {
		id: 'eoc.escalation-policies.common.ui.notify-all-members-of-team.no-translate',
		defaultMessage: 'Notify all members of team',
		description: 'The label of notify type "Notify all members of team" option',
	},
	notifyAdminsOfTeam: {
		id: 'eoc.escalation-policies.common.ui.notify-admins-of-team.no-translate',
		defaultMessage: 'Notify admin(s) of team',
		description: 'The label of notify type "Notify admin(s) of team" option',
	},
	notifyUsersOfTeam: {
		id: 'eoc.escalation-policies.common.ui.notify-users-of-team.no-translate',
		defaultMessage: 'Notify user(s) of team',
		description: 'The label of notify type "Notify user(s) of team" option',
	},
	notifyRandomMemberOfTeam: {
		id: 'eoc.escalation-policies.common.ui.notify-random-member-of-team.no-translate',
		defaultMessage: 'Notify random member of team',
		description: 'The label of notify type "Notify random member of team" option',
	},
	searchFor: {
		id: 'eoc.escalation-policies.common.ui.search-for.no-translate',
		defaultMessage: `Search for {type, select,
      user {user}
      schedule {schedule}
      other {team}
    }`,
		description: 'Placeholder of search {type} input',
	},
	timeMaxLimit: {
		id: 'eoc.escalation-policies.common.ui.time-max-limit.no-translate',
		defaultMessage: `Rule time cannot be greater than 1440 minutes.`,
		description: 'Error message of time limit that shown if time is bigger than 1440 minutes',
	},
	timeMinLimit: {
		id: 'eoc.escalation-policies.common.ui.time-min-limit.no-translate',
		defaultMessage: `Rule time cannot be negative number.`,
		description: 'Error message of time limit that shown if time is lesser than 0 minute',
	},
	fieldRequired: {
		id: 'eoc.escalation-policies.common.ui.field-required.no-translate',
		defaultMessage: `This field is required.`,
		description: 'Error message of inputs that shown when there is no value',
	},
	validNumber: {
		id: 'eoc.escalation-policies.common.ui.valid-number.no-translate',
		defaultMessage: `Enter a valid number.`,
		description: 'Error message of inputs that shown when there is no value',
	},
	save: {
		id: 'eoc.escalation-policies.common.ui.save.no-translate',
		defaultMessage: `Save`,
		description: 'Label of save rule input button',
	},
	cancel: {
		id: 'eoc.escalation-policies.common.ui.cancel.no-translate',
		defaultMessage: `Cancel`,
		description: 'Label of cancel rule input button',
	},
	deletedResponder: {
		id: 'eoc.escalation-policies.common.ui.deleted-responder.no-translate',
		defaultMessage: 'Deleted responder',
		description: 'Placeholder when responder is deleted',
	},
	deletedFieldRequired: {
		id: 'eoc.escalation-policies.common.ui.deleted-field-required.no-translate',
		defaultMessage: 'Select another responder.',
		description: 'Error message of inputs that shown when responder is deleted',
	},
	notifyConditionLabel: {
		id: 'eoc.escalation-policies.common.ui.rule-input.notify-condition-label.no-translate',
		defaultMessage: 'Notify condition',
		description: 'The label of notify condition input',
	},
	notifyActionLabel: {
		id: 'eoc.escalation-policies.common.ui.rule-input.notify-action-label.no-translate',
		defaultMessage: 'Notify action',
		description: 'The label of notify type input',
	},
});

export default messages;
